$( document ).ready(function() {
   $('.slider-product').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow:"<button type='button' class='slick-arrows slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='61' height='61' viewBox='0 0 61 61' fill='none'><circle cx='30.5' cy='30.5' r='30.5' transform='matrix(-1 0 0 1 61 0)' fill='#ECE4E4' fill-opacity='0.5'/><path d='M16.4803 31.3536C16.285 31.1583 16.285 30.8417 16.4803 30.6464L19.6623 27.4645C19.8575 27.2692 20.1741 27.2692 20.3694 27.4645C20.5646 27.6597 20.5646 27.9763 20.3694 28.1716L17.541 31L20.3694 33.8284C20.5646 34.0237 20.5646 34.3403 20.3694 34.5355C20.1741 34.7308 19.8575 34.7308 19.6623 34.5355L16.4803 31.3536ZM44 31.5H16.8338V30.5H44V31.5Z' fill='#906AA1'/></svg></button>",
    nextArrow:"<button type='button' class='slick-arrows slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='61' height='61' viewBox='0 0 61 61' fill='none'><circle cx='30.5' cy='30.5' r='30.5' fill='#ECE4E4' fill-opacity='0.5'/><path d='M44.5197 31.3536C44.715 31.1583 44.715 30.8417 44.5197 30.6464L41.3377 27.4645C41.1425 27.2692 40.8259 27.2692 40.6306 27.4645C40.4354 27.6597 40.4354 27.9763 40.6306 28.1716L43.459 31L40.6306 33.8284C40.4354 34.0237 40.4354 34.3403 40.6306 34.5355C40.8259 34.7308 41.1425 34.7308 41.3377 34.5355L44.5197 31.3536ZM17 31.5H44.1662V30.5H17V31.5Z' fill='#906AA1'/></svg></button>", 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.brand-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 4,
    arrows: true,
    prevArrow:"<button type='button' class='slick-arrows slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='61' height='61' viewBox='0 0 61 61' fill='none'><circle cx='30.5' cy='30.5' r='30.5' transform='matrix(-1 0 0 1 61 0)' fill='#ECE4E4' fill-opacity='0.5'/><path d='M16.4803 31.3536C16.285 31.1583 16.285 30.8417 16.4803 30.6464L19.6623 27.4645C19.8575 27.2692 20.1741 27.2692 20.3694 27.4645C20.5646 27.6597 20.5646 27.9763 20.3694 28.1716L17.541 31L20.3694 33.8284C20.5646 34.0237 20.5646 34.3403 20.3694 34.5355C20.1741 34.7308 19.8575 34.7308 19.6623 34.5355L16.4803 31.3536ZM44 31.5H16.8338V30.5H44V31.5Z' fill='#906AA1'/></svg></button>",
    nextArrow:"<button type='button' class='slick-arrows slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='61' height='61' viewBox='0 0 61 61' fill='none'><circle cx='30.5' cy='30.5' r='30.5' fill='#ECE4E4' fill-opacity='0.5'/><path d='M44.5197 31.3536C44.715 31.1583 44.715 30.8417 44.5197 30.6464L41.3377 27.4645C41.1425 27.2692 40.8259 27.2692 40.6306 27.4645C40.4354 27.6597 40.4354 27.9763 40.6306 28.1716L43.459 31L40.6306 33.8284C40.4354 34.0237 40.4354 34.3403 40.6306 34.5355C40.8259 34.7308 41.1425 34.7308 41.3377 34.5355L44.5197 31.3536ZM17 31.5H44.1662V30.5H17V31.5Z' fill='#906AA1'/></svg></button>", 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
	
});
